import './current-location.scss';

const CurrentLocation = (props) => {
	const { country_code, language, flag_URL } = props;

	return (
		<>
			<div className="current-location">
				<img
					className="current-location__flag"
					src={flag_URL}
					alt="selected location flag"
				></img>
				<p className="current-location__location">
					<span className="current-location__code">
						{country_code} {' - '}
						{language}
					</span>
				</p>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="current-location__arrow"
				>
					<path d="m6 9 6 6 6-6" />
				</svg>
			</div>
		</>
	);
};

export default CurrentLocation;
